import { combineReducers } from 'redux';
import update from 'immutability-helper';
import SelfServePostBuilderSidePanelConstants, { SelfServePostBuilderSidePanelTypes } from './SelfServePostBuilderSidePanelConstants';
import SectionOrganizerReducer from './SectionOrganizer/SectionOrganizerReducer';
import RecipientManagerReducer from './RecipientManager/RecipientManagerReducer';

const initialState = {
  activePanel: SelfServePostBuilderSidePanelTypes.SECTION_ORGANIZER,
};

const ActiveSidePanelHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SelfServePostBuilderSidePanelConstants.DISPLAY_PANEL_TYPE:
      return update(state, {
        activePanel: { $set: action.panelType },
      });
    default:
      return state;
  }
};

export default combineReducers({
  ActiveSidePanelHandler,
  SectionOrganizerReducer,
  RecipientManagerReducer,
});



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SelfServePostBuilderSidePanelReducer.jsx